<template>
  <zj-layout-container class="zj-resources-team-manage" v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header style="padding:0.8rem 0px 0px 0px;margin-left: 20rem;z-index: 2;">
      <div class="zj-button-bar">
        <el-button size="mini" @click="onAdd">添 加</el-button>
        <el-button size="mini" @click="onbatchDel">删 除</el-button>
      </div>
    </zj-layout-header>
    <zj-layout-main style="padding:0.8rem 0px 0px 0px;margin-top: -3.5rem;">
    <div class="group-container">
      <template v-for="item,ind in options">
        <div class="labelgroup">{{item.value}}</div>
        <div class="group-bar">
          <el-table
            v-if="tableData.length"
            :data="tableData[ind]"
            ref="multipleTable"
            @selection-change="selectionChange($event,ind)"
            border
            style="width: 100%"
            height="100%"
          >
            <!-- :ref="[ind == 0 ? 'multipleTable' : 'multipleTable' + (index + 1)]" -->
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column prop="name" label="姓名" align="center"></el-table-column>
            <el-table-column prop="title" label="职位" align="center"></el-table-column>
            <el-table-column prop="genderTranslated" label="性别" align="center"></el-table-column>
            <el-table-column prop="age" label="年龄" align="center"></el-table-column>
            <el-table-column prop="contactNo" label="联系方式" align="center"></el-table-column>
            <el-table-column prop="belongDeptIdTranslated" label="所属组织" align="center"></el-table-column>
            <el-table-column label="操作" width="130" align="center">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">查看</el-button>
                <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="divider-bar" v-if="ind < options.length - 1">
          <el-divider></el-divider>
        </div>
      </template>
      <!-- <div class="labelgroup">外部组织</div>
      <div class="group-bar">
        <el-table
          :data="tableData2"
          ref="multipleTable2"
          @selection-change="selectionChange2"
          border
          style="width: 100%"
          height="100%"
        >
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
          <el-table-column prop="name" label="姓名" align="center"></el-table-column>
          <el-table-column prop="TitleName" label="职位" align="center"></el-table-column>
          <el-table-column prop="genderTranslated" label="性别" align="center"></el-table-column>
          <el-table-column prop="age" label="年龄" align="center"></el-table-column>
          <el-table-column prop="contactNo" label="联系方式" align="center"></el-table-column>
          <el-table-column prop="belongDeptType" label="所属组织" align="center"></el-table-column>
          <el-table-column label="操作" width="130" align="center">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.$index,scope.row)" type="text" size="small">查看</el-button>
              <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="deleteClick(scope.$index,scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div> -->
    </div>
    </zj-layout-main>
  </zj-layout-container>
</template>

<script>
import ZJApp from "../../../../../app";
const utils = ZJApp.ZJUtils;

import { getDictionary } from "@/api/src/emergency_common";
import { list, remove } from "@/api/src/emergency_person";

export default {
  name: "ZjAddrescueteamlist",
  componentName: "ZjAddrescueteamlist",
  controller: "EmergencyResource",
  action: "Addrescueteamlist",
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      name: "",
      tableData: [],
      selectData: [],
      options: [],
    };
  },
  // 接受父组件传递的数据
  props: {
    belongDeptType: String
  },
  created() {
    this.basedatabind().then(()=>{
      this.onSearch();
    });
  },
  methods: {
    //基础数据绑定
    basedatabind() {
      this.loading = true;
      this.loadingText = '加载中...';
      return utils.waitAll([
        getDictionary('organization_nature'),
      ])
      .then(r => {

        //组织性质
        this.options = r[0].data.records;
        this.selectData = new Array(this.options.length)

        this.loading = false;

        return r;
      })
      .catch(e => {
        console.error(e);
        this.loading = false;
      });

    },
    searchinfo: function(obj) {
      this.search(obj);
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val,index) {
      // 将选中的数据存储起来
      this.selectData[index] = val;
    },
    search(info) {
      this.loading = true;
      this.loadingText = '加载中...';
      list(info).then(r => {
          r = r.data.records
          let tableData = new Array(this.options.length)
          this.options.map((item,index) =>{
            let arr = []
            r.map(child =>{
              if(child.organizationNature == item.code){
                arr.push(child)
              }
            })
            tableData[index] = arr
          })
          this.tableData = tableData;
          console.log(this.tableData)
          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.loading = false;
        });
    },
    // 点击查询按钮
    onSearch() {
      let searchInfo = {
        belongDeptType: this.belongDeptType,
        size: 2000,
        current: 1,
      };
      this.search(searchInfo);
    },

    //编辑按钮
    editClick(index, { id }) {
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/Addressbookinfo",
        query: {
          id,
          type: "edit",
          belongDeptType:this.belongDeptType
        }
      });
    },
    //查看详细
    handleClick(index, { id }) {
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/Addressbookinfo",
        query: {
          id,
          type: "search",
          belongDeptType:this.belongDeptType
        }
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/emergency/EmergencyResource/Addressbookinfo",
        query: {
          id: null,
          type: "edit",
          belongDeptType:this.belongDeptType
        }
      });
    },
    //批量删除
    onbatchDel() {
      let selection = [];
      this.selectData.map(item =>{
        selection = selection.concat(item || []);
      })
      if (selection.length > 0) {
        this.$confirm("选中的数据将被永久删除, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            // 清除 所有勾选项
            this.options.map((item,index) =>{
              this.$refs['multipleTable'][index].clearSelection()
            })
            let ids = selection.map(item =>item.id)
            this.delete(ids.join(','))
          });
      } else {
        this.$message({
          type: "info",
          message: "未选中任何行！"
        });
      }
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delete(row.id)
        });
    },
    delete(idList){
      this.loading = true;
      this.loadingText = '删除中...';
      remove({idList}).then(r => {
        r = r.data;
        if (r) {
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        } else {
          this.$message({
            type: "error",
            message: "删除失败!"
          });
        }
        this.loading = false;
        this.onSearch();
      })
      .catch(e => {
        this.loading = false;
      });
    },
  }
};
</script>